import validator from 'validator';

export default {
  name: 'UserEditionForm',
  components: {},
  props: {
    userDetails: {
      type: Object,
      required: true,
      default: () => {
      },
    },
  },
  data() {
    return {
      passwordRepeated: '',
      userUuid: null,
      loggedUser: null,
      user: {
        password: '',
      },
      rules: {
        password: [{ required: true, validator: this.__validatePassword, trigger: 'change' }],
        passwordRepeated: [{
          required: true,
          validator: this.__validatePasswordRepeated,
          trigger: 'change',
        }],
      },
    };
  },
  created() {
    this.userUuid = this.$router.currentRoute.params.userUuid;
    this.loggedUser = this.$store.getters['authorization/user'].user_uuid;
  },
  watch: {},
  computed: {
    isLoading() {
      return this.$store.getters['global/pendingAsyncStoreActions'].includes([
        'user/updateUser',
      ]);
    },
  },
  methods: {
    closeModal() {
      this.$emit('closeModal');
    },
    async submitForm() {
      const userData = this.$refs.userForm;
      const userParams = this.$refs.userForm.model;
      userData.validate(async (valid) => {
        if (valid) {
          let params = {};
          if (userParams.password.length !== 0) {
            params = {
              user: this.userDetails.user_uuid,
              password: userParams.password,
            };
          }
          await this.$store.dispatch('user/updateUser', params);
          this.$message({
            showClose: true,
            message: 'Hasło zostało zmienione',
            type: 'success',
          });
          await this.$store.dispatch('user/getDetails', this.userDetails.user_uuid);
          this.$emit('closeModal');
        }
      });
    },
    __validatePassword(rule, value, callback) {
      if (!validator.isLength(value, { min: 8 })) {
        callback('Hasło nie może być krótsze niż 8 znaków.');
        return;
      }
      if (value.replace(/[^A-Z]/g, '').length === 0) {
        callback('Hasło musi posiadać przynajmniej 1 wielką literę.');
        return;
      }
      if (value.replace(/[^0-9]/g, '').length === 0) {
        callback('Hasło musi posiadać przynajmniej 1 cyfrę.');
        return;
      }
      callback();
    },
    __validatePasswordRepeated(rule, value, callback) {
      if (this.user.password.length !== this.passwordRepeated.length) {
        callback('Podane hasła muszą być takie same');
        return;
      } if (this.user.password !== this.passwordRepeated) {
        callback('Podane hasła muszą być takie same');
        return;
      }
      callback();
    },
  },
};
